module.exports = __webpack_public_path__ + "img/vue.7395dd59.png";